import React, {Component} from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';
import Button from "@material-ui/core/Button";

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#c23d4b',
      },
    }
  }
};

class _CardForm extends Component {
  state = {
    errorMessage: '',
  };

  handleChange = ({error}) => {
    if (error) {
      this.setState({errorMessage: error.message});
    } else {
      this.setState({errorMessage: ""})
    }
  };

  handleSubmit = async (evt) => {
    evt.preventDefault();
    if (!this.props.stripe) {
      console.error("Stripe.js hasn't loaded yet.");
    } else {
      const { token } = await this.props.stripe.createToken();
      if (token) {
        this.props.createSubscription(token.id);
      };
    }
  };

  render() {
    return (
      <div className="CardDemo">
        <form onSubmit={this.handleSubmit.bind(this)}>
          <label>
            <p className={"mt-2"}>Enter your card details:</p>
            <CardElement
              onChange={this.handleChange}
              {...createOptions()}
            />
          </label>
          <div className="text-alert mt-2 ml-2" role="alert">
            {this.state.errorMessage}
          </div>
          <div className={"mt-3"}>
            <Button
              className={"stripe-submit-button"}
              variant="contained"
              color="secondary"
              onClick={this.handleSubmit.bind(this)}><span className="text-white">Pay</span></Button>
          </div>
        </form>
      </div>
    );
  }
}

export default injectStripe(_CardForm);
